var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"img-retina",style:(`width: ${_vm.imgWidth}`)},[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }